import React from 'react';
import { RouteConfig } from 'react-router-config';

import { HasToBeAllowedForInspectionsGuard } from '../../guards/HasToBeAllowedForInspectionsGuard';
import { HasToBeLoggedInGuard } from '../../guards/HasToBeLoggedInGuard';

const PREFIX = '/dcra-inspections/';

const dcraInspectionRoutes: Array<RouteConfig> = [
  {
    path: [PREFIX + 'inspection-create/:type'],
    component: React.lazy(
      () => import('../../../main/dcra-inspections/job-create/JobCreatePage')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeAllowedForInspectionsGuard],
  },
  {
    path: [PREFIX + 'inspection-create'],
    component: React.lazy(
      () => import('../../../main/dcra-inspections/job-create/JobCreatePage')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeAllowedForInspectionsGuard],
  },
  {
    path: [PREFIX + 'inspections/:status'],
    component: React.lazy(
      () => import('../../../main/dcra-inspections/inspections/InspectionsPage')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeAllowedForInspectionsGuard],
  },
  {
    path: [PREFIX + 'inspections'],
    component: React.lazy(
      () => import('../../../main/dcra-inspections/inspections/InspectionsPage')
    ),
    canActivate: [HasToBeLoggedInGuard],
  },
  {
    path: [PREFIX + 'inspection/:id/report', '/dir/:id'],
    component: React.lazy(
      () =>
        import(
          '../../../main/dcra-inspections/inspection-report/InspectionReportPage'
        )
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeAllowedForInspectionsGuard],
  },
  {
    path: [PREFIX + 'inspection/:id', '/di/:id'],
    component: React.lazy(
      () =>
        import('../../../main/construction/inspections/InspectionDetailsPage')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeAllowedForInspectionsGuard],
  },
];

export default dcraInspectionRoutes;
